import classes from './UserAgreement.module.sass'
import { Helmet } from 'react-helmet-async'
import { useLegality } from '../hooks/useLegality'

const COUNTRY = process.env.REACT_APP_COUNTRY || 'ru'
const DOMAIN = COUNTRY === 'ru' ? 'ru' : COUNTRY

const text = `
ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ

Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между Ночевкиным Сергеем Михайловичем (далее — Оператор) и любым физическим или юридическим лицом (далее — Пользователь), использующим веб-приложение и мобильное приложение, доступные по адресу https://logid.${DOMAIN} (далее — Приложение).

1. Общие положения
1.1. Приложение представляет собой программную платформу, предоставляющую Пользователю доступ к функциональности для ведения бизнеса: сайт, мобильное приложение, CRM.
1.2. Настоящее Соглашение является публичной офертой в соответствии со ст. 435 ГК РФ. Регистрация в Приложении является акцептом настоящей оферты в соответствии со ст. 438 ГК РФ.
1.3. Обязательным условием регистрации является подтверждение согласия с настоящим Соглашением путем отметки чекбокса. Без отметки чекбокса регистрация технически невозможна.

2. Термины и определения
2.1. Приложение — программная платформа logid.${DOMAIN}, включающая веб-интерфейс, мобильное приложение, CRM-систему и иные сервисы, предоставляемые Пользователю.
2.2. Оператор — Ночевкин Сергей Михайлович, лицо, обеспечивающее функционирование Приложения.
2.3. Пользователь — лицо, прошедшее процедуру регистрации в Приложении.
2.4. Аккаунт — совокупность данных Пользователя, создаваемая при регистрации и позволяющая использовать функциональность Приложения.
2.5. Арендатор — юридическое лицо или индивидуальный предприниматель, заключивший с Оператором договор аренды программного обеспечения (SaaS).
2.6. Конечный пользователь — физическое лицо, использующее сайты и приложения Арендаторов, работающие на платформе Оператора.

3. Регистрация и аккаунт
3.1. Для использования Приложения Пользователь проходит процедуру регистрации, предоставляя адрес электронной почты.
3.2. Код подтверждения направляется на указанный адрес электронной почты и является одноразовым.
3.3. Пользователь обязуется предоставлять достоверную информацию и поддерживать ее в актуальном состоянии.
3.4. Пользователь несет ответственность за сохранность своих учетных данных. Все действия, совершенные с использованием учетных данных Пользователя, считаются совершенными им лично.
3.5. Оператор оставляет за собой право в любой момент потребовать подтверждения данных, указанных при регистрации.

4. Функциональность Приложения
4.1. Приложение предоставляет Пользователю доступ к инструментам для ведения бизнеса, включая:
— создание и управление сайтом;
— использование мобильного приложения;
— работу с CRM-системой;
— иные сервисы, доступные в Приложении.
4.2. Состав и условия доступа к функциональности Приложения определяются тарифами и договором с Оператором.
4.3. Оператор оставляет за собой право изменять, дополнять или отключать отдельные функции Приложения с предварительным уведомлением Пользователя.

5. Права и обязанности Оператора
5.1. Оператор обязан:
— обеспечивать функционирование Приложения в соответствии с его назначением;
— принимать меры для защиты данных Пользователя в соответствии с Политикой конфиденциальности;
— не разглашать учетные данные Пользователя третьим лицам, за исключением случаев, предусмотренных законодательством РФ.
5.2. Оператор имеет право:
— проводить профилактические работы с временным приостановлением работы Приложения;
— вносить изменения в настоящее Соглашение с уведомлением Пользователя;
— блокировать доступ Пользователя к Приложению в случае нарушения условий настоящего Соглашения;
— направлять Пользователю информационные и рекламные сообщения. Пользователь вправе отказаться от их получения, направив уведомление на support@logid.${DOMAIN}.

6. Права и обязанности Пользователя
6.1. Пользователь обязан:
— соблюдать условия настоящего Соглашения и Политики конфиденциальности;
— не передавать свои учетные данные третьим лицам;
— не использовать Приложение для распространения спама, вредоносного ПО и иных противоправных действий;
— не осуществлять действия, направленные на нарушение работы Приложения;
— не использовать автоматизированные средства для сбора информации из Приложения без разрешения Оператора.
6.2. Пользователь имеет право:
— использовать функциональность Приложения в соответствии с условиями настоящего Соглашения;
— в любое время прекратить использование Приложения;
— обращаться к Оператору за разъяснениями по вопросам использования Приложения.

7. Интеллектуальная собственность
7.1. Программный код, дизайн, графическое и текстовое наполнение Приложения являются интеллектуальной собственностью Оператора и охраняются законодательством РФ.
7.2. Пользователь не имеет права копировать, модифицировать, распространять или иным образом использовать материалы Приложения без письменного разрешения Оператора.

8. Обработка персональных данных
8.1. Обработка персональных данных Пользователя осуществляется в соответствии с Политикой конфиденциальности, размещенной по адресу https://logid.${DOMAIN}.
8.2. Пользователь дает согласие на обработку своих персональных данных Оператором и обработчиком ПД — Ночевкиным С.М. (реестр РКН № 100340655) — для целей, указанных в Политике конфиденциальности.
8.3. Пользователь, являющийся Арендатором, обязуется самостоятельно получать согласие на обработку персональных данных от своих Конечных пользователей.

9. Ответственность
9.1. Оператор не несет ответственности за:
— перерывы в работе Приложения, вызванные техническими сбоями, действиями третьих лиц или обстоятельствами непреодолимой силы;
— достоверность информации, размещенной Пользователем;
— убытки, причиненные Пользователю в результате разглашения его учетных данных, произошедшего не по вине Оператора.
9.2. Пользователь несет ответственность за все действия, совершенные с использованием его учетных данных.

10. Разрешение споров
10.1. Все споры разрешаются путем переговоров с соблюдением претензионного порядка.
10.2. Претензии направляются на адрес электронной почты support@logid.${DOMAIN}. Срок рассмотрения претензии — 30 календарных дней.
10.3. При недостижении согласия спор передается в суд по месту нахождения Оператора.

11. Заключительные положения
11.1. Настоящее Соглашение вступает в силу с момента акцепта Пользователем и действует бессрочно.
11.2. Пользователь может расторгнуть Соглашение, прекратив использование Приложения. Если Пользователь не использует Приложение в течение 360 календарных дней, Соглашение считается расторгнутым.
11.3. Оператор может расторгнуть Соглашение в одностороннем порядке в случае нарушения Пользователем его условий.
11.4. Оператор оставляет за собой право вносить изменения в Соглашение. Новая редакция вступает в силу с момента ее опубликования в Приложении.
11.5. Актуальная редакция Соглашения размещена по адресу https://logid.${DOMAIN}.
`

export const UserAgreement = () => {
  useLegality()

  return (
    <div className={classes.TempContainer}>
      <Helmet>
        <title>logid - пользовательское соглашение</title>
        <meta name="description" content="Пользовательское соглашение платформы logid" />
      </Helmet>
      <div className={classes.Text}>{text}</div>
    </div>
  )
}
